"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
exports.StoreLocator = function (props) {
    var page = props.data.page;
    React.useEffect(function () {
        var getConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                (function (s, t, o, c, k) {
                    c = s.createElement(t);
                    c.src = o;
                    c.async = 1;
                    k = s.getElementsByTagName(t)[0];
                    k.parentNode.insertBefore(c, k);
                })(document, "script", "//stockist.co/embed/v1/widget.min.js");
                return [2 /*return*/];
            });
        }); };
        getConfig();
    });
    return (React.createElement(Snippets.Container, { tag: "section", collapsed: true, className: "relative block", key: "map", width: "full" },
        React.createElement("div", { className: "max-w-xl mx-auto mlg:px-11 md:px-2-4 px-1-6" },
            React.createElement(Snippets.Breadcrumbs, __assign({ className: "hidden md:block py-1-2 mb-2-4" }, props)),
            React.createElement("div", { className: "w-full flex md:flex-row flex-col items-center text-left md:pt-0 pt-2-4" },
                React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "font-extrabold tracking-none md:w-auto w-full md:mb-0 mb-2" }, page.title),
                page.content ? (React.createElement(Snippets.RichText, { size: "xsmall", className: "mt-0-4 text-center text-charcoal" }, page.content)) : null)),
        React.createElement("div", { className: "shadow-border w-full md:pt-2-6 pt-3-2" }),
        React.createElement("div", { className: "my-2 max-w-xl mx-auto mlg:px-11 md:px-2-4 px-1-6" },
            React.createElement("div", { className: "flex", "data-stockist-widget-tag": "u15982" },
                React.createElement("div", { className: "h-full md:w-1/4 px-1-6 pt-2-8 flex flex-col" },
                    React.createElement("div", { className: "w-full text-center" },
                        React.createElement("div", { className: "content-placeholder py-1 w-1/2 mx-auto" }),
                        React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-4/5 mx-auto" }),
                        React.createElement("div", { className: "content-placeholder py-0-5 mt-0-4 w-4/6 mx-auto" }),
                        React.createElement("div", { className: "flex items-between mt-1-8" },
                            React.createElement("div", { className: "w-2/3 pr-0-5" },
                                React.createElement("div", { className: "content-placeholder py-2" })),
                            React.createElement("div", { className: "w-1/3 pl-0-5" },
                                React.createElement("div", { className: "content-placeholder py-2" })))),
                    React.createElement("div", { className: "flex-1 w-full overflow-y-auto" },
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })),
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })),
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })),
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })),
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })),
                        React.createElement("div", { className: "w-full mt-3" },
                            React.createElement("div", { className: "content-placeholder py-1-2 w-1/3" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-1 w-1/2" }),
                            React.createElement("div", { className: "content-placeholder py-0-5 mt-0-5 w-3/4" })))),
                React.createElement("div", { className: "w-full md:w-3/4" },
                    React.createElement("div", { className: "w-full content-placeholder" }))))));
};
